<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

  <div class="d-flex align-items-center">
    <div>
      <el-form inline ref="form" :model="searchform">
        <el-form-item class="mb-0 mr-0">
          <el-date-picker
            v-model="searchform.time"
            type="datetimerange"
            range-separator="~"
            :start-placeholder="$t('searchText.시작')"
            :end-placeholder="$t('searchText.마감')"
            size="mini"
            class="mr-2"
            style="width:300px"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00','23:59:59']">
          </el-date-picker>
        </el-form-item>

        <el-form-item class="mb-0 mr-0">
          <el-button type="info" size="mini" @click="searchEvent">
            {{$t('searchText.검색')}}
          </el-button>
        </el-form-item>

        <el-form-item class="mb-0 mr-0">
          <div class="d-flex align-items-center">
            <span class="ml-2 mr-1">관리자 지급</span>
            <el-switch
              v-model="admin_in"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#cfcdcd"
              @change="getSwitch">
            </el-switch>

            <span class="mr-1 ml-1">관리자 차감</span>
            <el-switch
              v-model="admin_out"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#cfcdcd"
              @change="getSwitch">
            </el-switch>

            <span class="mr-1 ml-1">포인트 전환</span>
            <el-switch
              v-model="point_trans"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#cfcdcd"
              @change="getSwitch">
            </el-switch>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>

  <div v-if="this.userid=='admin'" class="d-flex mt-2">
    <el-input
      :placeholder="$t('searchText.구글OTP')"
      v-model="otp"
      size="mini"
      style="width: 100px;"
      class="mr-2">
    </el-input>

    <el-button type="danger" size="mini" @click="deleteAll">
      {{$t('searchText.선택삭제')}}
    </el-button>
  </div>

  <el-tabs v-model="activeName" @tab-click="handleClick" type="card" class="mt-2">

    <!-- 第一个：머니변동 -->
    <el-tab-pane :label="$t('tableText.머니변동')" name="one">
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%"
        border
        class="mt-2"
        :row-class-name="tableRowClassName"
        :empty-text="$t('tableText.데이타가없습니다')"
        @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="55" align="center"></el-table-column>

        <el-table-column width="50" align="center" label="ID">
          <template v-if="loading==false" slot-scope="scope">
            {{total-(currentPage-1)*50-scope.$index}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('nav.아이디')" prop="mem_id" align="center">
          <template slot-scope="scope">
            <span
              @click="openModel(scope.row.mem_id,'tab1')"
              class="text-primary"
              style="cursor:pointer">
              {{scope.row.mem_id}} ({{scope.row.mem_name}})
            </span>
          </template>
        </el-table-column>

        <el-table-column label="변동금액" prop="money" align="center">
          <template slot-scope="scope">
            <span
              class="bg-danger text-white mr-2 text-center"
              style="border-radius:100%;width:15px;height:15px;line-height:15px;display:inline-block;"
              v-if="scope.row.type==='4'||scope.row.type==='5'||scope.row.type==='6'||scope.row.type==='8'||scope.row.type==='9'">
              P
            </span>
            <span :class="func(scope.row.money)">
              {{ formatMoney(scope.row.money)}}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="변동후머니" prop="new_money" align="center">
          <template slot-scope="scope" v-if="scope.row.type!='1' && scope.row.type!='7'">
            <span :class="func(scope.row.new_money)">
              {{ formatMoney(scope.row.new_money)}}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="변동후롤링" prop="new_event" align="center">
          <template slot-scope="scope" v-if="scope.row.type!='1' && scope.row.type!='7'">
            <span :class="func(scope.row.new_event)">
              {{ formatMoney(scope.row.new_event)}}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="구분" prop="type" align="center">
          <template slot-scope="scope">
            {{typeObj[scope.row.type]}}
          </template>
        </el-table-column>

        <el-table-column label="메모" prop="doc" width="350" align="center">
          <template slot-scope="scope">
            {{scope.row.doc}}
            <el-button
              type="primary"
              v-if="scope.row.idx=='0'"
              size="mini"
              plain
              @click="logs(scope)">
              상세보기
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="시간" prop="add_time" align="center"></el-table-column>
      </el-table>

      <div style="height: 100px;"></div>

      <el-footer class="border-top d-flex align-items-center px-0 bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
        <div style="flex: 1;" class="px-2">
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </el-footer>
    </el-tab-pane>

    <!-- 第二个：포인트변동 -->
    <el-tab-pane label="포인트변동" name="two">
      <el-button type="primary" v-if="this.level=='3'" size="mini" @click="dayrogBtn">
        일자별롤링
      </el-button>

      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        border
        class="mt-2"
        empty-text="데이타가 없습니다"
        @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="55" align="center"></el-table-column>

        <el-table-column width="50" align="center" label="ID">
          <template v-if="loading==false" slot-scope="scope">
            {{total-(currentPage-1)*50-scope.$index}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('nav.아이디')" prop="mem_id" align="center">
          <template slot-scope="scope">
            <span
              @click="openModel(scope.row.mem_id,'tab1')"
              class="text-primary"
              style="cursor:pointer">
              {{scope.row.mem_id}} ({{scope.row.mem_name}})
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('tableText.베팅금액')" prop="point" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.point)}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('tableText.변동금액')" prop="money" align="center">
          <template slot-scope="scope">
            <span
              class="bg-danger text-white mr-2 text-center"
              style="border-radius:100%;width:15px;height:15px;line-height:15px;display:inline-block;"
              v-if="scope.row.type==='4'||scope.row.type==='5'||scope.row.type==='6'||scope.row.type==='8'||scope.row.type==='9'">
              P
            </span>
            <span :class="scope.row.money <0 ? 'text-danger':'text-success'">
              {{ formatMoney(scope.row.money)}}
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('tableText.변동후머니')" prop="new_money" align="center">
          <template slot-scope="scope" v-if="scope.row.type!='1' && scope.row.type!='7'">
            {{ formatMoney(scope.row.new_money)}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('tableText.변동후롤링')" prop="new_event" align="center">
          <template slot-scope="scope" v-if="scope.row.type!='1' && scope.row.type!='7'">
            {{ formatMoney(scope.row.new_event)}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('searchText.구분')" prop="type" align="center">
          <template slot-scope="scope">
            {{typeObj[scope.row.type]}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('tableText.메모')" width="350" prop="doc" align="center">
          <template slot-scope="scope">
            {{scope.row.doc}}
            <el-button
              type="primary"
              v-if="scope.row.idx=='0'"
              size="mini"
              plain
              @click="logs(scope)">
              {{$t('msg.상세보기')}}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column :label="$t('tableText.시간')" prop="add_time" align="center"></el-table-column>
      </el-table>

      <div style="height: 100px;"></div>

      <el-footer class="border-top d-flex align-items-center px-0 bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
        <div style="flex: 1;" class="px-2">
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </el-footer>
    </el-tab-pane>

    <!-- 第三个：유저별롤링 -->
    <el-tab-pane :label="$t('newMsg.유저별롤링')" name="three">
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%"
        border
        class="mt-2"
        show-summary
        :summary-method="getSummaries"
        :empty-text="$t('tableText.데이타가없습니다')">

        <el-table-column width="50" align="center" label="ID">
          <template v-if="loading==false" slot-scope="scope">
            {{scope.$index + 1}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('msg.매장')" prop="c_code" align="center"></el-table-column>

        <el-table-column :label="$t('msg.아이디')" prop="bet_id" align="center">
          <template slot-scope="scope">
            <span
              style="cursor:pointer"
              class="text-primary"
              @click="openModel(scope.row.bet_id,'tab1')">
              {{scope.row.bet_id}}
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('msg.카배팅')" prop="ebet" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.ebet)}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('msg.슬배팅')" prop="sbet" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.sbet)}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('msg.카롤링')" prop="elog" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.elog)}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('msg.슬롤링')" prop="slog" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.slog)}}
          </template>
        </el-table-column>

        <el-table-column :label="$t('searchText.시작')" prop="stime" align="center"></el-table-column>

        <el-table-column :label="$t('searchText.마감')" prop="etime" align="center"></el-table-column>
      </el-table>

      <div style="height: 100px;"></div>
    </el-tab-pane>

  </el-tabs>

  <el-dialog :visible.sync="dialogVisible" :width="memWidth" :close-on-click-modal="false">
    <el-table
      :data="tableData_id"
      v-loading="loading_id"
      style="width: 100%"
      border
      class="mt-2"
      :empty-text="$t('tableText.데이타가없습니다')"
      @selection-change="handleSelectionChange">

      <el-table-column width="50" align="center" label="ID">
        <template v-if="loading_id==false" slot-scope="scope">
          {{total_id-(currentPage_id-1)*50-scope.$index}}
        </template>
      </el-table-column>

      <el-table-column :label="$t('nav.아이디')" prop="mem_id" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.mem_id}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('tableText.이름')" prop="mem_name" align="center">
        <template slot-scope="scope">
          {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})
        </template>
      </el-table-column>

      <el-table-column :label="$t('tableText.변동금액')" prop="money" align="center">
        <template slot-scope="scope">
          <span
            class="bg-danger text-white mr-2 text-center"
            style="border-radius:100%;width:15px;height:15px;line-height:15px;display:inline-block;"
            v-if="scope.row.type==='4'||scope.row.type==='5'||scope.row.type==='6'||scope.row.type==='8'||scope.row.type==='9'">
            P
          </span>
          <span :class="scope.row.type==='1'||scope.row.type==='2'||scope.row.type==='3'||scope.row.type==='7' ? 'text-danger':'text-success'">
            {{ formatMoney(scope.row.money)}}
          </span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('tableText.변동후머니')" prop="new_money" align="center">
        <template slot-scope="scope">
          {{ formatMoney(scope.row.new_money)}}
        </template>
      </el-table-column>

      <el-table-column :label="$t('tableText.변동후롤링')" prop="new_event" align="center">
        <template slot-scope="scope">
          {{ formatMoney(scope.row.new_event)}}
        </template>
      </el-table-column>

      <el-table-column :label="$t('searchText.구분')" prop="type" align="center">
        <template slot-scope="scope">
          {{typeObj[scope.row.type]}}
        </template>
      </el-table-column>

      <el-table-column :label="$t('tableText.메모')" prop="doc" align="center">
        <template slot-scope="scope">
          {{scope.row.doc}}
        </template>
      </el-table-column>

      <el-table-column :label="$t('tableText.시간')" prop="add_time" align="center"></el-table-column>
    </el-table>

    <div style="height: 100px;"></div>

    <el-footer class="border-top d-flex align-items-center px-0 bg-white" style="z-index: 100;">
      <div style="flex: 1;" class="px-2">
        <el-pagination
          :current-page="currentPage_id"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="size_id"
          layout="prev, pager, next"
          :total="total_id"
          @size-change="handleSizeChangeId"
          @current-change="handleCurrentChangeId">
        </el-pagination>
      </div>
    </el-footer>
  </el-dialog>

  <div class="dialogLayer" v-show="shareShow" @click="shareShow=!shareShow"></div>
</div>
</template>

<script>
import layer from '../../components/common/layer.vue'
import layerNew from '../../components/common/layer-new.vue'
import dayrog from '../../components/common/dayrog.vue'

export default {
  components: {
    layer,
    layerNew,
    dayrog
  },

  data() {
    return {
      admin_in: 0,
      admin_out: 0,
      point_trans: 0,

      dialogVisible: false,
      shareShow: false,
      memWidth: '1100px',

      activeName: 'one',
      tapidx: '0',

      otp: '',
      multipleSelection: [],

      level_title: {
        '-2': this.$i18n.t('msg.블랙'),
        '-1': this.$i18n.t('msg.대기'),
        '0': this.$i18n.t('msg.기본')
      },

      domain: window.sessionStorage.getItem('domain'),
      sitetype: window.sessionStorage.getItem('sitetype'),
      bg: window.sessionStorage.getItem('bg'),
      userid: window.sessionStorage.getItem('userid'),
      aid: window.sessionStorage.getItem('admin_id'),
      level: window.sessionStorage.getItem('level'),

      formLoading: false,
      idDialogVisible: false,

      total_money: 0,

      typeObj: {
        '31': this.$i18n.t('msg.입금보너스'),
        '1': this.$i18n.t('msg.배팅'),
        '7': this.$i18n.t('msg.당첨'),
        '2': this.$i18n.t('msg.입금'),
        '3': this.$i18n.t('msg.출금'),
        '4': this.$i18n.t('msg.롤링전환'),
        '5': this.$i18n.t('msg.롤링지급'),
        '12': this.$i18n.t('msg.매장롤링'),
        '15': this.$i18n.t('msg.본사롤링'),
        '16': this.$i18n.t('msg.마스터롤링'),
        '6': this.$i18n.t('msg.총판롤링'),
        '8': this.$i18n.t('msg.부본사롤링'),
        '9': this.$i18n.t('msg.회원롤링'),
        '10': this.$i18n.t('msg.알충전'),
        '11': this.$i18n.t('msg.알환전'),
        '21': this.$i18n.t('msg.사이트머니카지노머니전환'),
        '22': this.$i18n.t('msg.카지노머니사이트머니전환')
      },

      searchform: {
        keyword: '',
        time: [],

        searchOptions: [
          { label: this.$i18n.t('msg.전체'), value: '' },
          { label: this.$i18n.t('msg.입금보너스'), value: '31' },
          { label: this.$i18n.t('msg.배팅'), value: '1' },
          { label: this.$i18n.t('msg.당첨'), value: '7' },
          { label: this.$i18n.t('msg.입금'), value: '2' },
          { label: this.$i18n.t('msg.출금'), value: '3' },
          { label: this.$i18n.t('msg.이벤트전환'), value: '4' },
          { label: this.$i18n.t('msg.이벤트지급'), value: '5' },
          { label: this.$i18n.t('msg.매장롤링'), value: '12' },
          { label: this.$i18n.t('msg.총판롤링'), value: '6' },
          { label: this.$i18n.t('msg.부본사롤링'), value: '8' },
          { label: this.$i18n.t('msg.회원롤링'), value: '9' },
          { label: this.$i18n.t('msg.알충전'), value: '10' },
          { label: this.$i18n.t('msg.알환전'), value: '11' },
          { label: this.$i18n.t('msg.사이트머니카지노머니전환'), value: '21' },
          { label: this.$i18n.t('msg.카지노머니사이트머니전환'), value: '22' }
        ],

        searchOptions1: [
          {
            label: this.$i18n.t('msg.아이디'),
            value: 'mem_id'
          }
        ],

        value1: 'mem_id',
        value: '',
        value2: ''
      },

      pickerOptions: {},

      shortcuts: [
        {
          text: this.$i18n.t('dateText.최근한주'),
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: this.$i18n.t('dateText.최근한달'),
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: this.$i18n.t('dateText.최근3개월'),
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }
      ],

      user_id: '',
      type_id: '',
      stime_id: '',
      etime_id: '',

      loading: false,
      loading_id: false,

      editIndex: -1,
      creatModel: false,

      tableData: [],
      currentPage: 1,
      total: 0,
      size: 0,

      tableData_id: [],
      currentPage_id: 1,
      total_id: 0,
      size_id: 0
    }
  },

  created() {
    this.tabsCode()
  },

  methods: {
    tabsCode() {
      if (this.$route.query.activeName != null) {
        this.activeName = this.$route.query.activeName

        if (this.activeName === 'two') {
          this.tapidx = '1'
        }

        if (this.activeName === 'three') {
          this.tapidx = '2'
        }
      }

      this.getList()
    },

    getSummaries(param) {
      const { columns, data } = param
      const sums = []

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$i18n.t('msg.합계')
          return
        }

        if (!column.property) {
          sums[index] = ''
          return
        }

        const values = data.map(item => Number(item[column.property]))

        if (!values.every(value => isNaN(value))) {
          const total = values.reduce((prev, curr) => {
            const value = Number(curr)
            return !isNaN(value) ? prev + value : prev
          }, 0)

          sums[index] = this.formatMoney(total)
        } else {
          sums[index] = ''
        }
      })

      return sums
    },

    logs(e) {
      this.dialogVisible = true
      this.user_id = e.row.mem_id
      this.type_id = e.row.type
      this.stime_id = e.row.add_time
      this.etime_id = e.row.add_time
      this.getList_id()
    },

    handleClose() {
      this.idDialogVisible = false
    },

    cancelData() {
      this.idDialogVisible = false
    },

    func(state) {
      if (state > 0) {
        return 'text-success'
      } else if (state < 0) {
        return 'text-danger'
      } else {
        return ''
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'odd-row-class'
      } else {
        return 'edd-row-class'
      }
    },

    cancelEvent() {
      this.shareShow = false
    },

    dayrogBtn() {
      this.$layer.iframe({
        type: 2,
        title: '일자별롤링',
        content: {
          content: dayrog,
          parent: this
        },
        shadeClose: true,
        maxmin: true,
        shade: false,
        area: ['1000px', '500px']
      })
    },

    openModel(id, e) {
      this.shareShow = true

      let pix = window.screen.width
      let width = '1000px'

      if (pix < 1200) {
        width = '95%'
      }

      this.$layer.iframe({
        type: 2,
        title: id,
        content: {
          content: layerNew,
          parent: this,
          data: {
            info: { id: id },
            activeTab: e,
            model: this.shareShow,
            layerid: 'id'
          }
        },
        shadeClose: true,
        maxmin: true,
        shade: false,
        area: [width + '', '500px'],
        cancel: () => {
          this.shareShow = false
        }
      })
    },

    getSwitch() {
      this.currentPage = 1
      this.getList()
    },

    searchEvent() {
      if (this.searchform.keyword !== '' && this.searchform.value1 === '') {
        this.$message(this.$i18n.t('msg.검색타이틀선택하세요'))
        return
      }

      this.currentPage = 1
      this.getList()
    },

    handleSizeChange(val) {
      this.size = val
      this.getList()
      this.loading = true
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
      this.loading = true
    },

    handleSizeChangeId(val) {
      this.size_id = val
      this.getList_id()
      this.loading_id = true
    },

    handleCurrentChangeId(val) {
      this.currentPage_id = val
      this.getList_id()
      this.loading_id = true
    },

    deleteAll() {
      this.$confirm(this.$i18n.t('msg.삭제하시겠습니까복구불가'), this.$i18n.t('msg.알림'), {
        confirmButtonText: this.$i18n.t('msg.삭제'),
        cancelButtonText: this.$i18n.t('msg.취소'),
        type: 'warning'
      }).then(() => {
        let token = window.sessionStorage.getItem('user')
        let newids = []

        this.multipleSelection.forEach(item => {
          newids.push(item.id)
        })

        this.$axios({
          method: 'post',
          data: {
            idx: newids,
            opt: this.otp
          },
          url: this.domain + '/user/moneylogs_del',
          Accept: 'application/json',
          headers: {
            Authorization: 'Bearer ' + token
          }
        }).then((response) => {
          if (response.data.code == 200) {
            this.$message({
              message: response.data.msg,
              type: 'success'
            })
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }

          this.getList()
        }).catch((error) => {
          console.log(error)
        })
      })
    },

    handleClick(tab, event) {
      this.tapidx = tab.index
      this.currentPage = 1
      this.getList()
    },

    getList() {
      let s_time = ''
      let e_time = ''
      let v = this.tapidx

      if (this.searchform.time.length > 0) {
        s_time = this.searchform.time[0]
        e_time = this.searchform.time[1]
      }

      this.loading = true

      let urls = ''

      if (v == '0') {
        urls = this.domain
          + '/user/moneylogs?log=1'
          + '&post=' + this.searchform.value2
          + '&type=' + this.searchform.value
          + '&s_time=' + s_time
          + '&e_time=' + e_time
          + '&' + this.searchform.keyword
          + '&admin_in=' + this.admin_in
          + '&admin_out=' + this.admin_out
          + '&point_trans=' + this.point_trans
          + '&page=' + this.currentPage
      } else if (v == '1') {
        urls = this.domain
          + '/user/moneylogs?log=2'
          + '&post=' + this.searchform.value2
          + '&type=' + this.searchform.value
          + '&s_time=' + s_time
          + '&e_time=' + e_time
          + '&' + this.searchform.keyword
          + '&admin_in=' + this.admin_in
          + '&admin_out=' + this.admin_out
          + '&point_trans=' + this.point_trans
          + '&page=' + this.currentPage
      } else if (v == '2') {
        urls = this.domain
          + '/user/moneylogs_user?s_time=' + s_time
          + '&e_time=' + e_time
      }

      let token = window.sessionStorage.getItem('user')

      this.$axios({
        method: 'get',
        url: urls,
        Accept: 'application/json',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then((response) => {
        if (v == '2') {
          this.tableData = response.data.data || []
          this.total = this.tableData.length
          this.currentPage = 1
          this.size = this.tableData.length
          this.total_money = response.data.total_money || 0
          this.loading = false
        } else {
          let data = response.data.data

          this.tableData = data.data
          this.total = data.total
          this.currentPage = data.current_page
          this.size = data.per_page
          this.total_money = response.data.total_money

          this.loading = false
        }
      }).catch((error) => {
        this.$message.error(error)
        this.loading = false
      })
    },

    getList_id() {
      let ttt = this.type_id
      let id = this.user_id
      let s_time = this.stime_id.substring(0, 10) + ' 00:00:00'
      let e_time = this.etime_id.substring(0, 10) + ' 23:59:59'

      this.loading_id = true

      let urls = ''
      let v = this.tapidx

      if (v == '0') {
        urls = this.domain
          + '/user/moneylogs?log=1'
          + '&post=&type=' + ttt
          + '&s_time=' + s_time
          + '&e_time=' + e_time
          + '&mem_id=' + id
          + '&page=' + this.currentPage_id
      } else {
        urls = this.domain
          + '/user/moneylogs?log=0'
          + '&post=&type=' + ttt
          + '&s_time=' + s_time
          + '&e_time=' + e_time
          + '&mem_id=' + id
          + '&page=' + this.currentPage_id
      }

      let token = window.sessionStorage.getItem('user')

      this.$axios({
        method: 'get',
        url: urls,
        Accept: 'application/json',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then((response) => {
        let data = response.data.data

        this.tableData_id = data.data
        this.total_id = data.total
        this.currentPage_id = data.current_page
        this.size_id = data.per_page

        this.loading_id = false
      }).catch((error) => {
        this.$message.error(error)
        this.loading_id = false
      })
    }
  }
}
</script>

<style scoped>
/deep/ .el-form-item__content {
  display: flex;
  align-items: center;
  line-height: 30px;
}

/deep/ .el-dialog {
  height: 700px;
  overflow-y: scroll;
}

/deep/ .el-input__inner {
  height: 30px;
  line-height: 30px;
}

/deep/ .el-form-item__label {
  line-height: 30px;
}

/deep/ .el-dialog__body {
  padding: 10px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/moneylogs_user/list.vue